import type React from 'react';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import BuildIcon from '@mui/icons-material/Build';
import PauseIcon from '@mui/icons-material/Pause';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ListIcon from '@mui/icons-material/List';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

/** Map icon name (from flow config) to MUI icon component */
export const ICON_COMPONENTS: Record<string, React.ElementType> = {
  Schedule: ScheduleIcon,
  ThumbUpAlt: ThumbUpAltIcon,
  DirectionsCar: DirectionsCarIcon,
  Build: BuildIcon,
  Pause: PauseIcon,
  LocalShipping: LocalShippingIcon,
  TaskAlt: TaskAltIcon,
  ReceiptLong: ReceiptLongIcon,
  CheckCircle: CheckCircleIcon,
  Cancel: CancelIcon,
};

/** Fallback icon per status — used when flow config icon not found */
export const FALLBACK_STATUS_ICONS: Record<string, React.ElementType> = {
  all: ListIcon,
  // Work-order list chip for statuses outside the tenant's flow (#2881)
  other: MoreHorizIcon,
  pending: HourglassEmptyIcon,
  confirmed: CheckCircleOutlineIcon,
  vehicle_arrived: DirectionsCarIcon,
  in_progress: BuildIcon,
  paused: PauseCircleOutlineIcon,
  waiting_parts: LocalShippingIcon,
  work_completed: AssignmentTurnedInIcon,
  ready_to_invoice: ReceiptLongIcon,
  invoiced: ReceiptLongIcon,
  completed: CheckCircleIcon,
  cancelled: CancelIcon,
  scheduled: HourglassEmptyIcon,
  waiting_approval: ThumbUpAltIcon,
};

export function getStatusIconComponent(
  statusKey: string,
  statusIcons: Record<string, string>,
): React.ElementType {
  const iconName = statusIcons[statusKey];
  if (iconName && ICON_COMPONENTS[iconName]) return ICON_COMPONENTS[iconName];
  return FALLBACK_STATUS_ICONS[statusKey] ?? HourglassEmptyIcon;
}
